import React, { useEffect, useState } from 'react';
import { Alert, Modal, Box, ButtonGroup, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';

export default function ApplicationListsModal({ list, type, onTriggerCreate, onTriggerUpdate }) {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const isFormValid = Object.values(errors).filter(value => value !=='').length > 0;

  const handleOpen = () => {
    setOpen(true);
    setTitle(`Create ${type} List`);
  }

  const handleEditOpen = () => {
    setOpen(true);
    setTitle(`Update ${type} List`);
  }

  const handleClose = () => setOpen(false);

  const handleUpdate = async(event) => {
      await createList(event);
      handleClose(list);
      if ( title === `Create ${type} List` ) {
        onTriggerCreate(formData);
      } else {
        onTriggerUpdate(formData);
      }      
  }

  const [formData, setFormData] = useState({
      id: '',
      type: '',
      name: '',
  })

  const handleInputChange = (field) => (event) => {
      const value = event.target.value;
      setFormData(prev => ({
          ...prev,
          [field]: value
      }));
      
      if (errors[field]) {
          setErrors(prev => ({
              ...prev,
              [field]: ''
          }));
      }
      
      if (successMessage) {
          setSuccessMessage('');
      }
  };
  
  const [successMessage, setSuccessMessage] = useState('');
  
  const [title, setTitle] = useState('');
  
  const createList = async (event) => {

    try {
      event.preventDefault();
      if (formData.id === '') {
        const response = await fetch(`${process.env.REACT_APP_API}/appLists/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        const result = await response.json();
          if (result.message !== 'Success') {
            toast.error(result.message);
          }
        } else {
          const response = await fetch(`${process.env.REACT_APP_API}/appLists/${formData.id}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
          });

          const result = await response.json();
          if (result.message !== 'Success') {
            toast.error(result.message);
          }

        }
    } catch (error) {
      console.error('Network error.  Please try again: ', error);
    }
  };
  
  const textFieldStyles = Styles.textFieldStyles;

  useEffect(() => {
    if (list.id !== undefined) {
      setFormData(list);      
    } else {
      setFormData(prev => ({ ...prev, type: type }));
    }
  }, [list, type] );

  return (
    <>
        { formData.id === "" && 
          <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen}>
            Add New
          </Button>
        }
        
        { formData.id !== '' && 
          <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
              <EditIcon />
          </Button>
        }
        
        <Modal 
          open={open} 
          onClose={handleClose}
          style={{
            overlay: {
              backgroundColor: '#080030', // Semi-transparent black
            },
            content: {
              backgroundColor: '#080030',
            },
          }}
        >
            <Box sx={{color: 'white', p: 4}}>
                <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                    mx: 'auto',
                    width: 400,
                    bgcolor: '#1e1e1e',
                    p: 2,
                  }}
                >
                  {successMessage && (
                    <Alert severity="success" sx={{ mb: 3 }}>
                      {successMessage}
                    </Alert>
                  )}
          
                  {errors.submit && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                      {errors.submit}
                    </Alert>
                  )}
                  <Typography variant="h4" component="h2" color="white" mb={2}>
                    {title}
                  </Typography>

                  <Box component="form" onSubmit={handleUpdate}>
                    <Stack spacing={2}>
                      <TextField
                        required
                        fullWidth
                        label="Name"
                        value={formData.name}
                        onChange={handleInputChange('name')}
                        error={!!errors.name}
                        helperText={errors.name}
                        sx={ textFieldStyles }
                      />
                      
                    <ButtonGroup 
                        size="small"
                        variant="contained" 
                        aria-label="Basic button group" 
                        fullWidth
                        sx={{ mt:2 }}
                    >
                        <Button
                        onClick={handleClose}
                        type="cancel"
                        variant="contained"
                        sx={ Styles.buttonStyle }
                        >
                        Cancel
                        </Button>              
                        <Button
                        type="submit"                      
                        variant="contained"
                        disabled={isFormValid}
                        sx={{ ...Styles.buttonStyle,  ml:4 }}
                        >
                          {title}
                        </Button>
                    </ButtonGroup>
                  </Stack>
              </Box>
            </Box>
          </Box>
        </Modal>            
    </>
  );
}